import r from "../../shared-lib/braze-shared-lib.js";
import y from "../common/base-provider.js";
import e from "../managers/braze-instance.js";
import { STORAGE_KEYS as i } from "../managers/storage-manager.js";
import E from "../managers/subscription-manager.js";
import { randomInclusive as D } from "../util/math.js";
import C from "../util/net.js";
import {
  newFeatureFlagFromJson as st,
  newFeatureFlagFromSerializedValue as it,
} from "./feature-flag-factory.js";
import T from "../util/request-header-utils.js";
export default class er extends y {
  constructor(t, s, i) {
    super(),
      (this.wt = t),
      (this.gt = s),
      (this.u = i),
      (this.pi = []),
      (this.gi = 0),
      (this.wt = t),
      (this.gt = s),
      (this.u = i),
      (this.Fi = null),
      (this.wi = new E()),
      (this.yi = 10),
      (this.ji = null),
      (this.bi = null),
      e.jt(this.wi);
  }
  Ts(t) {
    if ((!this.wt || this.wt.vi()) && null != t && t.feature_flags) {
      this.pi = [];
      for (const s of t.feature_flags) {
        const t = st(s);
        t && this.pi.push(t);
      }
      (this.gi = new Date().getTime()), this.Ti(), this.wi.Et(this.pi);
    }
  }
  Di() {
    let t = {};
    this.u && (t = this.u.v(i.k.Ri));
    const s = {};
    for (const i in t) {
      const e = it(t[i]);
      e && (s[e.id] = e);
    }
    return s;
  }
  Ni() {
    var t;
    return (null === (t = this.u) || void 0 === t ? void 0 : t.v(i.k.qi)) || {};
  }
  xi(t) {
    this.u && this.u.D(i.k.qi, t);
  }
  ri(t) {
    return this.wi.lt(t);
  }
  refreshFeatureFlags(t, s, i = !1, e = !0) {
    if (!this.zi(i))
      return (
        !this.Fi &&
          this.wt &&
          (this.Fi = this.wt.Ci(() => {
            this.refreshFeatureFlags(t, s);
          })),
        void ("function" == typeof s && s())
      );
    if ((e && this.Ii(), !this.gt)) return void ("function" == typeof s && s());
    const r = this.gt.Bs({}, !0),
      h = this.gt.Hs(r, T.Os.Si);
    let o = !1;
    this.gt.Qs(r, () => {
      this.gt
        ? (T.Ws(this.u, T.Os.Si, new Date().valueOf()),
          C.Xs({
            url: `${this.gt.Ys()}/feature_flags/sync`,
            headers: h,
            data: r,
            O: (i) => {
              if (!this.gt.Zs(r, i, h))
                return (o = !0), void ("function" == typeof s && s());
              this.gt.ti(),
                this.Ts(i),
                (o = !1),
                T.si(this.u, T.Os.Si, 1),
                "function" == typeof t && t();
            },
            error: (t) => {
              this.gt.ii(t, "retrieving feature flags"),
                (o = !0),
                "function" == typeof s && s();
            },
            ei: () => {
              if (e && o && !this.bi) {
                T.hi(this.u, T.Os.Si);
                let e = this.ji;
                (null == e || e < 1e3 * this.yi) && (e = 1e3 * this.yi),
                  this.$i(Math.min(3e5, D(1e3 * this.yi, 3 * e)), t, s, i);
              }
            },
          }))
        : "function" == typeof s && s();
    });
  }
  Ii() {
    null != this.bi && (clearTimeout(this.bi), (this.bi = null));
  }
  $i(t = 1e3 * this.yi, s, i, e = !1) {
    this.Ii(),
      (this.bi = window.setTimeout(() => {
        this.refreshFeatureFlags(s, i, e);
      }, t)),
      (this.ji = t);
  }
  zi(t) {
    if (!this.wt) return !1;
    if (!t) {
      const t = this.wt.Mi();
      if (null == t) return !1;
      let s = !1;
      if (!isNaN(t)) {
        if (-1 === t) return r.j.info("Feature flag refreshes not allowed"), !1;
        s = new Date().getTime() >= (this.gi || 0) + 1e3 * t;
      }
      if (!s)
        return (
          r.j.info(`Feature flag refreshes were rate limited to ${t} seconds`),
          !1
        );
    }
    return this.wt.vi();
  }
  Ti() {
    if (!this.u) return;
    const t = {};
    for (const s of this.pi) {
      const i = s.ss();
      t[s.id] = i;
    }
    this.u.D(i.k.Ri, t), this.u.D(i.k.Ui, this.gi);
  }
}
